"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var throttle_1 = __importDefault(require("lodash/throttle"));
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var TransformUserSettings_1 = require("./TransformUserSettings");
var TransformAccountSettings_1 = require("./TransformAccountSettings");
module.exports = function ($rootScope, make, account, styleWorker, user, persist, usingFeature, apiBaseUrl) {
    var e_1, _a;
    var options;
    $rootScope.$$persistAccount = account;
    $rootScope.$$persistUser = user;
    var persistItems = [
        {
            name: "styles",
            successMsg: "Updated Styles",
            onPersisted: (0, throttle_1.default)(styleWorker.renderAccountStyleSheet, 2000),
        },
        {
            name: "settings",
            successMsg: "Updated Settings",
            watchObjectTransformer: TransformAccountSettings_1.transformAccountSettings,
        },
    ];
    if (usingFeature(FeatureFlag_1.FeatureFlag.AcceptCustomForms)) {
        persistItems.push({
            name: "forms",
            successMsg: "Updated Forms",
        });
    }
    try {
        for (var persistItems_1 = __values(persistItems), persistItems_1_1 = persistItems_1.next(); !persistItems_1_1.done; persistItems_1_1 = persistItems_1.next()) {
            var item = persistItems_1_1.value;
            options = {
                watchObject: "$$persistAccount.".concat(item.name),
                apiRoute: "".concat(apiBaseUrl, "/accounts/").concat(account._id, "/").concat(item.name),
                expectedSuccessMsg: item.successMsg,
            };
            if (item.onPersisted != null) {
                options.onPersisted = item.onPersisted;
            }
            if (item.watchObjectTransformer != null) {
                options.watchObjectTransformer = item.watchObjectTransformer;
            }
            make(persist, { options: options });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (persistItems_1_1 && !persistItems_1_1.done && (_a = persistItems_1.return)) _a.call(persistItems_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    make(persist, {
        options: {
            watchObject: "$$persistUser.settings",
            apiRoute: "".concat(apiBaseUrl, "/users/").concat(user._id, "/settings"),
            expectedSuccessMsg: "Updated Settings",
            dataTransformer: TransformUserSettings_1.transformUserSettings,
        },
    });
    make(persist, {
        options: {
            watchObject: "$$persistUser.useHistory",
            apiRoute: "".concat(apiBaseUrl, "/users/history"),
        },
    });
};
